import { useState, useCallback, useEffect, useRef } from "react";
import { useAPILinkMix } from "hooks";
import axios from "axios";

export const useBuscarProductsIntegracaoApi = source => {
  const api = useAPILinkMix();
  const [dataItems, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback((params = {}) => {
    setLoading(true);
    api
      .post("/busca-produtos", params, {
        cancelToken: source.token,
      })
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    return () => {
      console.log(`Removendo`);
      // source.cancel();
    };
  }, []);

  return {
    isLoading: loading,
    data: dataItems,
    // cancel: source,
    fetch,
  };
};
